import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { environment } from '@env/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class LgpdService {

  constructor(private httpClient: HttpClient) { }

  verificarTermoUsuario(cpf, siglaSistema, siglaTermo): Observable<any> {
    return this.httpClient
      .get(`${environment.url_api_lgpd}/api/lgpd/termo/usuario/${cpf}/${siglaSistema}/${siglaTermo}`);
  }

  verificarTermoUsuarioPromise(cpf, siglaSistema, siglaTermo): Promise<any> {
    // return throwError('erro ao verificar termo usuario').toPromise();
    return this.httpClient.get(`${environment.url_api_lgpd}/api/lgpd/termo/usuario/${cpf}/${siglaSistema}/${siglaTermo}`).toPromise();
  }

  aceitarTermoUsuario(obj: any): Observable<any> {
    const json = JSON.stringify(obj);
    return this.httpClient.post(`${environment.url_api_lgpd}/api/lgpd/termo/usuario`, json, httpOptions);
  }

  carregarTermoSistema(siglaSistema, siglaTermo): Observable<any> {
    return this.httpClient
      .get(`${environment.url_api_lgpd}/api/lgpd/termo/sistema/${siglaSistema}/${siglaTermo}`);
  }
}
